/**
 * On non native platforms we do not need to implement a keyboard spacer, so we return a null component.
 *
 * @returns {null}
 * @constructor
 */
const KeyboardSpacer = () => null;

export default KeyboardSpacer;
